import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-flexbox-grid';
import { map, keys, sort, descend, is, cond, identity, T, isNil, always, compose, join, omit } from 'ramda';
import moment from 'moment';

import { isPartial, formatPartial } from 'lib/dateDisplay';

import Title from './Title';
import Section from './Section';

import { optFrom, optTo, arrow, editLabel } from './EditLog.less';

const handleOpt = (msg, opt) =>
  cond([
    [is(Number), identity],
    [isPartial, formatPartial],
    [is(Array), compose(join(', '), map(msg))],
    [isNil, always('')],
    [T, msg],
  ])(opt);

const handleCStatement = (opt, val) => {
  if (!val) return '';
  val = omit(['date', 'timestamp', 'done'], val);
  const mappedValues = map(v =>
    val[v] ? (
      <div key={v}>
        <div style={{ fontWeight: 400 }}>{opt('benefits.statement.labels.' + v)}</div>
        <div>{val[v]}</div>
      </div>
    ) : (
      ''
    ),
  );
  return mappedValues(keys(val));
};

const renderEditsPerDay = (label, opt) => (day, edits) => (
  <Section key={day} date={moment(day).format('Do MMMM YYYY')}>
    {map(e => (
      <Row key={`${e.field}_${e.time}`} className={editLabel}>
        <Col xs={12} sm={4}>
          <div>{label(e.field)}</div>
        </Col>
        <Col xs={4} sm={3}>
          <div className={optFrom}>
            {e.field === 'statements' ? handleCStatement(opt, e.from[0]) : handleOpt(opt, e.from)}
          </div>
        </Col>
        <Col xs={4} sm={1}>
          <div className={arrow}>{'->'}</div>
        </Col>
        <Col xs={4} sm={4}>
          <div className={optTo}>
            {e.field === 'statements' ? handleCStatement(opt, e.to[0]) : handleOpt(opt, e.to)}
          </div>
        </Col>
      </Row>
    ))(edits)}
  </Section>
);

class EditLog extends Component {
  constructor(props) {
    super(props);
    this.renderEdits = renderEditsPerDay(props.labelMessage, props.optionMessage);
    this.state = { hidden: true };
    this.handleToggle = () => {
      this.setState({ hidden: !this.state.hidden });
    };
  }

  render() {
    const { edits } = this.props;
    const { renderEdits, handleToggle } = this;
    const { hidden } = this.state;
    const sortedDates = sort(
      descend(x => moment(x).valueOf()),
      keys(edits),
    );

    return (
      <div>
        <Title localeId="editlog.title" action={handleToggle} isHidden={hidden} />
        {!hidden && map(f => renderEdits(f, edits[f]), sortedDates)}
      </div>
    );
  }
}

EditLog.propTypes = {
  edits: PropTypes.object.isRequired,
  localeMessage: PropTypes.func.isRequired,
  labelMessage: PropTypes.func.isRequired,
  optionMessage: PropTypes.func.isRequired,
};

export default EditLog;
